package org.lennycodes.hldi.pages.admin

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import org.lennycodes.hldi.components.Routes
import org.lennycodes.hldi.data.Event

@Page(Routes.events)
@Composable
fun AdminEvent(){

    AdminLayout {

        Events()

    }

}